var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('sidebar'),_c('div',{staticClass:"page-container"},[_c('topbar'),_c('main',{staticClass:"main-content bgc-grey-100"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }